import Image from "next/image";

const renderBlock = ({ imgUrl, imgAlt, copy }) => {
  return (
    <div className="col">
      <Image src={imgUrl} alt={imgAlt} width={64} height={64} />
      <h6 className="heading body--md">{copy}</h6>
    </div>
  );
};

const Arrow = () => (
  <Image
    src="/leadership/interview-process-arrow.svg"
    alt="arrow"
    width={24}
    height={24}
    className="arrow"
  />
);

const InterviewProcess = ({ head, block1, block2, block3, block4, block5 }) => {
  return (
    <section className="interview-process full">
      <div className="interview-process__banner banner">
        <div className="interview-process__copy">
          <div className="section-header">
            <h3 className="heading heading--md"> {head} </h3>
          </div>
          <div className="cols">
            {renderBlock(block1)}
            <Arrow />
            {renderBlock(block2)}
            <Arrow />
            {renderBlock(block3)}
            <Arrow />
            {renderBlock(block4)}
            <Arrow />
            {renderBlock(block5)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InterviewProcess;
